import React from "react"

function TastoSelezionaTab({
  idTasto,
  onClickTasto,
  tab,
  vociMenuTabsSelezionata,
  vociMenuTabs,
  icona,
  testo,
  alignRight,
}) {
  let classTasto = "tastoSelezionaTab w-100-ns ";

  if (tab === idTasto) {
    classTasto = classTasto + vociMenuTabsSelezionata;
  } else {
    classTasto = classTasto + vociMenuTabs;
  }

  if (alignRight) {
    classTasto += " justify-end";
  }

  return (
    <div id={idTasto} onClick={onClickTasto} className={classTasto}>
      {alignRight ? (
        <>
          <div className="modificaOrdiniTabLabel mr2 dn db-ns" id={idTasto}>
            {testo}
          </div>
          <div className="material-icons scrittaColoreAltScuro" id={idTasto}>
            {icona}
          </div>
        </>
      ) : (
        <>
          <div className="material-icons scrittaColoreAltScuro" id={idTasto}>
            {icona}
          </div>
          <div className="modificaOrdiniTabLabel ml2 dn db-ns" id={idTasto}>
            {testo}
          </div>
        </>
      )}
    </div>
  );
}

export default TastoSelezionaTab;



